import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=58e7f1d4"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=58e7f1d4&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e7f1d4')) {
      api.createRecord('58e7f1d4', component.options)
    } else {
      api.reload('58e7f1d4', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=58e7f1d4", function () {
      api.rerender('58e7f1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/payment.vue"
export default component.exports